import {findParameterWithContext} from './findParameter.js';

export default superclass => class extends superclass  {
    getParamsJson() {
        return {
            parameters: this._parameters.map(x => ({
                id: x.id,
                context: x.context && x.context.getJson(),
                name: x.name,
                coordinates: x.getCoordinates()
            })),
            depthParameters: this.depthParameters.map(
                x => x.getJson())
        };
    }

    fromParamsJson(json, isCopy) {
        delete json.depth;
        this.parametersJson = json.parameters;
        let bulk = {}; //super.fromJson(json, isCopy);


        // keep track of any parameters that we've lost so we can search for them
        // at the end of load
        this.lostParameters = this.loadParameters(json.parameters, true).lostParameters;
        this.loadDepthJson(json, isCopy);

        return bulk;
    }

    loadParameters(parameters, initialLoad=false) {
        let newMappings = {};

        // upon initial load, dont use the context to try to find parameters
        // if the ids dont match
        // but upon second load, if we dont find the id we want, we use the context
        // to find a best match
        let sequencerEngine = this.sequencerEngine;
        let lostParameters = [];
        for (let parameter of parameters) {
            let id = typeof parameter === "object" ? parameter.id : parameter;
            // need to find the parameter within the tracks
            let foundParameter = undefined;
            if (parameter.name === "BPM") {
                foundParameter = sequencerEngine.bpmParameter;
            }

            // look at higher order sequencer
            let {higherOrderSequencer} = sequencerEngine;
            if (!foundParameter && higherOrderSequencer) {
                let parameters = higherOrderSequencer.macros.map(x => x.macroParameter);
                foundParameter = parameters.find(p => id === p.id);
            }

            if (!foundParameter) {
                for (let subSequence of sequencerEngine.subSequences) {
                    for (let t of subSequence.tracks) {
                        let _foundParameter = t.getAllParameters().find(p => id === p.id);
                        if (_foundParameter) {
                            foundParameter = _foundParameter;
                            break;
                        }
                    }
                }
            }

            if (!foundParameter) {
                // then we need to look at lfo parameters and envelope parameters
                for (let subSequence of sequencerEngine.subSequences) {
                    for (let lfo of subSequence.lfos) {
                        lfo = lfo.lfo;
                        let _foundParameter = lfo.parameters.find(p => id === p.id);
                        if (_foundParameter) {
                            foundParameter = _foundParameter;
                            break;
                        }
                    }
                }
            }
            if (!foundParameter) {
                for (let subSequence of sequencerEngine.subSequences) {
                    let effects = [... subSequence.midiEffects.effects, subSequence.playhead];
                    let _parameters = [
                        ... effects.flatMap(x => x.getParameters()),
                        ... subSequence.pads.filter(
                            p => p.fxMacro)
                            .map(pad => pad.fxMacro.macroParameter),
                        ... subSequence.pads.filter(
                            p => p.effectRack)
                            .map(pad => pad.effectRack.getParameters())
                    ];
                    foundParameter = _parameters.find(p => id === p.id);
                    if (foundParameter) {
                        break;
                    }
                }
            }
            if (!foundParameter) {
                let _parameters = sequencerEngine.sends.sends.flatMap(x => x.effects)
                    .flatMap(x => x.getParameters());
                foundParameter = _parameters.find(p => id === p.id);
            }

            if (!foundParameter) {
                for (let subSequence of sequencerEngine.subSequences) {
                    for (let env of subSequence.envelopes) {
                        let _foundParameter = env.parameters.find(p => id === p.id);
                        if (_foundParameter) {
                            foundParameter = _foundParameter;
                            break;
                        }
                    }
                }
            }


            if (!foundParameter && !initialLoad && typeof parameter === "object") {
                foundParameter = findParameterWithContext(
                    parameter, this.track, sequencerEngine);
                // need to map the id to this found parameter
                if (foundParameter) {
                    newMappings[id] = foundParameter;
                    let {x,y} = parameter.coordinates;
                    // foundParameter.setCoordinates(x, y);
                }
            } 

            if (foundParameter) {
                this.setParameter(foundParameter);
            } else {
                lostParameters.push(parameter);
            }
        }

        this.sortParameters();
        return {lostParameters, newMappings};
    }

    sortParameters() {
        if (!this.parametersJson) {
            return;
        }
        let parameters = this.parametersJson.map(
            ({id}, i) => this._parameters.find(
                p => p && p.id === id))
            .filter(p => p);
        this._parameters = parameters;
    }

    loadDepthJson(json, isCopy) {
        if (json.depthParameters) {
            let i = 0;
            for (let _depthParameter of json.depthParameters) {
                let depthParameter = this.newDepthParameter();
                depthParameter.fromJson(_depthParameter, this.sequencerEngine, isCopy);
                this.depthParameters[i++] = depthParameter;
            }
        }
    }
}
